/**
 * 전자계약 조회권한 관리 API (SPEC-CONTRACT-VIEW-GRANT-001)
 *
 * v3 화면들과 같은 contracts-api 인스턴스(src/contractsApi.js)를 그대로 쓴다. 다만 v3 api.js와 달리
 * (params, success, fail) 콜백 형태 대신 얇게 Promise 를 그대로 반환한다 — 이 화면 전용 신규 API라
 * 기존 화면과 시그니처를 맞출 필요가 없고, 호출부(ContractViewPolicy.vue)에서 async/await 로 쓰기 쉽다.
 */
import contractsApi from '@/contractsApi';

const get = (url, config) => contractsApi.get(url, config).then((res) => res.data);
const post = (url, body) => contractsApi.post(url, body).then((res) => res.data);
// DELETE 는 axios 관례상 body를 { data } 로 넘긴다 (v3 api.js deleteContracts와 동일 패턴)
const del = (url, body) => contractsApi.delete(url, { data: body }).then((res) => res.data);

export const getPolicy = () => get('/contract-view/policy');
export const getOptions = () => get('/contract-view/options');
export const searchAccounts = (query) => get('/contract-view/accounts', { params: { query } });

export const addCsEngineer = (body) => post('/contract-view/cs-engineers', body);
export const removeCsEngineer = (username, body) => del(`/contract-view/cs-engineers/${encodeURIComponent(username)}`, body);

export const addPersonalGrant = (body) => post('/contract-view/personal-grants', body);
export const removePersonalGrant = (id, body) => del(`/contract-view/personal-grants/${encodeURIComponent(id)}`, body);

export const addDeptLineage = (body) => post('/contract-view/dept-lineages', body);
export const removeDeptLineage = (id, body) => del(`/contract-view/dept-lineages/${encodeURIComponent(id)}`, body);

export const evaluateAccount = (username) => get('/contract-view/evaluate', { params: { username } });

// 직원별 조회 권한 탭(전 직원 목록 + 필터/검색/페이지네이션) — SPEC 직원별 조회 권한 개편
export const listAccountEvaluations = (params) => get('/contract-view/accounts/evaluations', { params });
